// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__9NCTK","loader":"loader_loader__yafBG","rotation":"loader_rotation__Ja6ec","rotationBack":"loader_rotationBack__bK789"};